module.exports = __webpack_public_path__ + "images/application/illustrations/outbound-104cbf10.svg";